import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Employee } from "../models/employee"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { Users } from "../models/users";
import { EmployeeSecretary } from "../models/employeesecretary";

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'employee/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllEmployees(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Employee>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllEmployees?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  } 
  getAll_Employees(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Employee>> { 
    return this.httpService.get(this.apiEndpoint + 'getAll_Employees?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  } 
  viewEmployee(EmployeeID?: string): Observable<Array<Employee>> {
    return this.httpService.get(this.apiEndpoint + 'viewEmployee/' + (EmployeeID ? EmployeeID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  
  getEmployee(EmployeeID?: string): Observable<Array<Employee>> {
    return this.httpService.get(this.apiEndpoint + 'viewEmployee/' + (EmployeeID ? EmployeeID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  getDocumentPath(RefId?: any): Observable<Array<any>> {
    return this.httpService.get(this.apiEndpoint + 'getDocumentPath/'+ (RefId ? RefId : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveEmployee(employees: Employee): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveEmployee/', employees).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkEmail(Emailid?: string, EmployeeId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&EmployeeId=' + (EmployeeId ? EmployeeId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  checkPhone(Phone?: string, EmployeeId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkPhone?Phone=' + (Phone ? Phone : '')+ '&EmployeeId=' + (EmployeeId ? EmployeeId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  deleteEmployee(EmployeeID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteEmployee/' + (EmployeeID ? EmployeeID : '00000000-0000-0000-0000-000000000000'), EmployeeID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(EmployeeCode?: string,EmployeeId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?EmployeeCode=' + (EmployeeCode ? EmployeeCode : '')+ '&EmployeeId=' + (EmployeeId ? EmployeeId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }

  getAllUsers(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Users>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllUsers?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  } 

  getUserslistByEmployeeId(Emp_Ref_Id?: string): Observable<Array<Users>> { 
    return this.httpService.get(this.apiEndpoint + 'getEmployeePrivateCommentDetailsById/' + (Emp_Ref_Id ? Emp_Ref_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {            
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  } 
  getAll_SecretaryEmployees(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<EmployeeSecretary>> { 
    return this.httpService.get(this.apiEndpoint + 'getAll_Employees?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  } 
}
